import { handleChunkLoadError } from '@hydra/utils/handleChunkLoadError';

export default ({
  path: 'pdf-editor',
  async getComponent (nextState) {
    const {
      default: PdfEditorContainer
    } = await import(/* webpackChunkName: "pdf-editor-contianer" */ './containers/PdfEditorContainer.jsx')
      .catch(handleChunkLoadError);
    return PdfEditorContainer;
  },
  children: [
    {
      path: '',
      async getComponent (nextState) {
        const {
          default: PdfEditorOverview
        } = await import(/* webpackChunkName: "pdf-editor-overview" */ './containers/PdfEditorOverview')
          .catch(handleChunkLoadError);
        return PdfEditorOverview;
      },
      getData ({ context: { props } }) {
        return props;
      }
    },
    {
      path: ':id',
      async getComponent (nextState) {
        const {
          default: PdfEditorForm
        } = await import(/* webpackChunkName: "pdf-editor-form" */ './containers/PdfEditorForm')
          .catch(handleChunkLoadError);
        return PdfEditorForm;
      },
      getData ({ context: { props } }) {
        return props;
      }
    }
  ]
});
